module.exports = __webpack_public_path__ + "img/DOTAGA-FAP-2286-ALB.bd1edf6c.png";